<div class="row">
  <div class="col-12">
    <div class="card">
      <form [formGroup]="formGroup">
        <div class="card-body">
          <div class="row">
            <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 input-trend-search mb-1"
            >
              <input
                type="search"
                #searchBox
                class="form-control"
                [placeholder]="'contactGroup.panel.search' | translate"
                (keyup)="search(searchBox.value)"
              />
              <span class="mdi mdi-magnify search-icon ml-2"></span>
            </div>
            <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2 btn-group trend-button"
            >
              <button class="btn btn-info fw-bold" (click)="add()">
                {{ 'contactGroup.panel.add' | translate }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="card p-1">
  @if(loadingContent) {
  <content-loading-list />
  }
  @if(pager.total === 0 && !loadingContent) {
  <empty-records-component
    [message]="'contactGroup.panel.emptyMessage' | translate" [subMessage]="'contactGroup.panel.emptySubMessage' | translate"
    [icon]="'mdi mdi-account-alert'"
    [labelButton]="'contactGroup.panel.add' | translate"
    (emitEvent)="add()"
  />

}

  @if(toggleTableCard){
  @if (!loadingContent && pager.total > 0) {
    <div class="row g-2 align-items-stretch">
      @for(item of pager.list; track item) {
      <div class="col-12 col-sm-6 col-lg-4 col-xl-5ths">
        <div
          class="card-button-hover h-100"
          (click)="listContactGroup(item._id); $event.stopPropagation()"
          style="cursor: pointer"
        >
          <div class="card h-100 shadow-sm">
            <div class="p-2">
              <div class="d-flex align-items-center border-bottom py-2">
                <div class="avatar me-2 rounded-circle">
                  <img
                    alt="{{ item?.name }}"
                    src="../../../assets/images/logo-icon-sidebar.png"
                    class="img-fluid avatar-sm rounded-circle"
                  />
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex align-items-center g-2 flex-wrap">
                    <h6
                      class="mb-0 fs-5 fw-bold"
                      [matTooltip]="item?.name?.length > 10 ? $safeNavigationMigration(item?.name) : null"
                    >
                      {{ item?.name }}
                    </h6>
                  </div>
                </div>
                <div class="d-flex justify-content-end">
                  <button
                    class="btn btn-dropdown-list"
                    [matMenuTriggerFor]="menu"
                    type="button"
                    (click)="$event.stopPropagation()"
                    (mousedown)="$event.stopPropagation()"
                  >
                    <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                  </button>

                  <mat-menu #menu="matMenu">
                    <button
                      mat-menu-item
                      tabindex="0"
                      (click)="edit(item); $event.stopPropagation()"
                    >
                      {{ 'contactGroup.panel.edit' | translate }}
                    </button>

                    <button
                      mat-menu-item
                      tabindex="0"
                      (click)="delete(item); $event.stopPropagation()"
                    >
                      {{ 'contactGroup.panel.remove' | translate }}
                    </button>
                  </mat-menu>
                </div>
              </div>
              <div class="d-flex align-items-center g-2 mt-3">
                <span class="text-muted fw-bold mb-4">
                  {{ getCountContacts(item._id) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  }
  } @else { @if(pager.total > 0) {
  <div class="table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">{{ 'contactGroup.panel.columnGroup' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'contactGroup.panel.columnParticipantsCount' | translate }}</th>
          <th class="sr-only"></th>
          <th class="sr-only"></th>
        </tr>
      </thead>
      <tbody>
        @for (item of pager.list; track $index) {
        <tr
          (click)="listContactGroup(item._id); $event.stopPropagation()"
          style="cursor: pointer"
        >
          <td>
            <span>
              <img
                class="img-fluid avatar-sm"
                src="../../../assets/images/logo-icon-sidebar.png"
                alt="{{ item?.name }}"
              />
              {{ item?.name }}
            </span>
          </td>
          <td>
            <span>
              {{ getCountContacts(item._id) }}
            </span>
          </td>
          <td>
            <p>
              <span class="px-2 py-1 text-white rounded"> </span>
            </p>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <button
                class="btn btn-dropdown-list"
                [matMenuTriggerFor]="menu"
                type="button"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
              >
                <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
              </button>

              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="edit(item); $event.stopPropagation()"
                >
                  {{ 'contactGroup.panel.edit' | translate }}
                </button>

                @if(isAdmin()) {
                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="delete(item); $event.stopPropagation()"
                >
                  {{ 'contactGroup.panel.remove' | translate }}
                </button>
                }
              </mat-menu>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  } } @if (pager.total > pager.perPage) {
  <paginator [pager]="pager" (onPager)="loadPage($event)" />
  }
</div>
